import type { Camera } from "@/renderer/camera";

export const MIN_ZOOM = 0.01;
export const MAX_ZOOM = 2560;

export function clampZoom(zoom: number): number {
  return Math.max(MIN_ZOOM, Math.min(MAX_ZOOM, zoom));
}

export function screenToDocument(clientX: number, clientY: number, canvas: HTMLCanvasElement, camera: Camera) {
  const rect = canvas.getBoundingClientRect();
  return {
    x: camera.x + (clientX - rect.left) / camera.zoom,
    y: camera.y + (clientY - rect.top) / camera.zoom,
  };
}
